import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { PageService } from 'src/app/core/page/page.service';
import { selectActiveLanguage } from 'src/app/store/language/selectors';
import { AppStateInterface } from 'src/app/store/types';

@Component({
    selector: 'app-terms-and-conditions',
    templateUrl: './terms-and-conditions.component.html',
    styleUrl: './terms-and-conditions.component.scss',
    imports: [TranslateModule]
})
export class TermsAndConditionsComponent {

  languageDirection: string = 'ltr'

  constructor(private _store: Store<AppStateInterface>,
              private _pageService: PageService,
              private _translate: TranslateService){}

  ngOnInit(){
    this._store.select(selectActiveLanguage).subscribe({
      next: (activeLanguage) => {
        this.languageDirection =  this._pageService.getLanguageDirection(activeLanguage)
      }
    })
  }
}
